import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M8 1.253A6.745 6.745 0 1 0 14.751 8 6.76 6.76 0 0 0 8 1.253Zm-.5 1.53V7.5H2.781A5.237 5.237 0 0 1 7.5 2.783Zm1 10.43V8.5h4.72a5.236 5.236 0 0 1-4.72 4.713Z';
const draw24px =
  'M12,2.25A9.75,9.75,0,1,0,21.749,12,9.763,9.763,0,0,0,12,2.25Zm-.75,1.53v7.47H3.779A8.279,8.279,0,0,1,11.249,3.78Zm1.5,16.44V12.75h7.47A8.279,8.279,0,0,1,12.749,20.22Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const LevelsIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'levels'),
) as IconWithRender;

LevelsIcon.displayName = 'LevelsIcon';
LevelsIcon.propTypes = Icon.propTypes;
LevelsIcon.renderIcon = (props) => <LevelsIcon {...props} />;
export default LevelsIcon;
